import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import * as fromElasticSearchBox from '@offconon/shared/ui/search-box';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromElasticSearchBox.ELASTICSEARCHBOX_FEATURE_KEY,
      fromElasticSearchBox.elasticSearchBoxReducer,
    ),
    EffectsModule.forFeature(fromElasticSearchBox.ElasticSearchBoxEffects),
  ],
})
export class ElasticSearchBoxFeatureModule {}
